import { CHART_COLORS } from '../constants/constants';

export const SEA_AREA_COLORS: Record<string, string> = {
	'North Atlantic':   '#183D57',
	'South Atlantic':   '#819391',
	'North Pacific':    '#001537',
	'South Pacific':    '#569FD3',
	'Indian Ocean':     '#1E503E',
	'South China Sea':  '#F0D035',
	'Mediterranean':    '#9A2C56',
	'Baltic':           '#3F4B4B',
	'Black Sea':        '#52A5CF',
	'Inland FSU':       '#307731',
	'Arctic':           '#DDEDE9',
	'Antarctica':       '#9BD7F1',
};

export const REGION_COLORS: Record<string, string> = {
	'North America':    '#183D57',
	'Latin America':    '#DF6721',
	'Western Europe':   '#9A2C56',
	'Eastern Europe':   '#3F4B4B',
	'FSU':              '#8B6914',
	'Northern Africa':  '#DDEDE9',
	'Western Africa':   '#1E503E',
	'Eastern Africa':   '#307731',
	'Southern Africa':  '#52A5CF',
	'Middle East':      '#27709F',
	'South Asia':       '#F0D035',
	'South East Asia':  '#569FD3',
	'North East Asia':  '#001537',
	'Oceania':          '#9BD7F1',
};

const makeFallbackRegistry = (reserved: Record<string, string>): ((label: string) => string) => {
	const registry = new Map<string, string>();
	const reservedColors = new Set(Object.values(reserved));
	let index = 0;

	return (label: string): string => {
		if (!registry.has(label)) {
			while (reservedColors.has(CHART_COLORS[index % CHART_COLORS.length])) {
				index++;
			}
			registry.set(label, CHART_COLORS[index % CHART_COLORS.length]);
			index++;
		}
		return registry.get(label)!;
	};
};

const fallbackSeaAreaColor = makeFallbackRegistry(SEA_AREA_COLORS);
const fallbackRegionColor = makeFallbackRegistry(REGION_COLORS);

export const getSeaAreaColor = (label: string): string =>
	SEA_AREA_COLORS[label] ?? fallbackSeaAreaColor(label);

export const getRegionColor = (label: string): string =>
	REGION_COLORS[label] ?? fallbackRegionColor(label);
